import "./StrengthSection.css";
import img1 from "../assets/strengtha.webp";
import img2 from "../assets/strengthb.webp";
import { useEffect } from "react";

export default function StrengthSection() {

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("str-visible");
        }
      });
    }, { threshold: 0.2 });

    document.querySelectorAll(".str-fade-left, .str-fade-right").forEach(el => {
      observer.observe(el);
    });
  }, []);

  return (
    <section className="str-section">

      {/* CARD 1 - SAME AS BBIA */}
      <div className="str-wrapper">
        <div className="str-card">

          <div className="str-content str-fade-left">
            <h2>Our Strengths</h2>
            <p>
              At Bihani Children's Academy, our academic excellence, strong
              discipline and caring mentorship help students grow into confident
              achievers.
            </p>

            <a href="/strength" className="str-link">Explore More →</a>
          </div>

          <img src={img2} className="str-image str-fade-right" alt="Strength" />
        </div>
      </div>

      {/* CARD 2 - REVERSED */}
      <div className="str-wrapper">
        <div className="str-card str-reverse">

          <img src={img1} className="str-image str-fade-left" alt="Why Choose Us" />

          <div className="str-content str-fade-right">
            <h2>Why Choose Us?</h2>
            <p>
              We provide smart classrooms, digital learning tools, skilled teachers,
              and a value-based environment that nurtures real potential.
            </p>

            <a href="/whychoose" className="str-link">Learn More →</a>
          </div>

        </div>
      </div>

    </section>
  );
}